'use strict';

angular.module('AcaApp').controller('AccountLockedController',
[
  '$scope',
  'MsgBetweenCtrlService',
  function($scope, MsgBetweenCtrlService){
    $scope.errorMessage = MsgBetweenCtrlService.data.errorMessage;
  }
]);